"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _ = require('lodash');

var React = require('react');

var ReactDOM = require('react-dom');

var KEYS = require('../constants/keyCodes');

var commonPropTypes = require('../common/propTypes');

var preventNextMouseUp = function preventNextMouseUp(e) {
  e.preventDefault();
  e.target.removeEventListener('mouseup', preventNextMouseUp);
};

var createInputClass = function createInputClass(displayName, template, defaultPropOverride) {
  var Input = /*#__PURE__*/function (_React$Component) {
    _inherits(Input, _React$Component);

    var _super = _createSuper(Input);

    function Input(props) {
      var _this;

      _classCallCheck(this, Input);

      _this = _super.call(this, props);
      _this.timers = {};

      if (props.inputWithStateHandler) {
        _this.state = {
          value: props.value || ''
        };
      }

      _this.handleChange = function (e) {
        e.persist();
        var onChange = _this.props.onChange;

        if (_.isFunction(onChange)) {
          var isValid = true;
          /**
           * inputWithStateHandler:
           * Used for validate values with DOM events
           * When you must validate input value with outer logic, use this for setting input value
           */

          if (_this.props.inputWithStateHandler) {
            var stateValue = _this.props.inputWithStateHandler(e.target.value, _this.state.value);

            _this.setState({
              value: stateValue
            }, function () {
              onChange(stateValue, isValid);
            });
          } else {
            onChange(e.target.value, isValid);
          }
        }
      };

      _this.isDisabled = function () {
        return _this.props.disabled === true;
      };

      _this.getInputElement = function () {
        return ReactDOM.findDOMNode(_this.refs.input);
      };

      _this.focusFailed = false;

      _this.blurInput = function () {
        var element = _this.getInputElement();

        if (element) {
          element.blur();
        }
      };

      _this.focusInput = function () {
        var select = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var element = _this.getInputElement();

        if (element) {
          element.focus();

          if (select) {
            _this.selectContent();
          }

          _this.focusFailed = element !== window.document.activeElement;

          if (_this.focusFailed) {
            _this.forceUpdate();
          }
        }
      };

      _this.handleKeyDown = function (e) {
        var keyCode = e.keyCode;
        var isEsc = keyCode === KEYS.ESC;
        var isEscAndBlur = isEsc && _this.props.blurOnEscKey;
        var isEnter = keyCode === KEYS.ENTER;
        var isEnterAndBlur = isEnter && _this.props.blurOnEnterKey;

        if (isEscAndBlur || isEnterAndBlur) {
          _this.isCanceled = isEscAndBlur;

          _this.blurInput();
        }

        _this.props.onKeyDown(e, _this.blurInput);
      };

      _this.scrollInputToTopIfNeeded = function () {
        _this.getInputElement().scrollTop = 0;
      };

      _this.selectContent = function () {
        var inputElement = _this.getInputElement();

        if (!inputElement) {
          return;
        }

        if (_.isFinite(_this.props.initialSelectionStart) && _.isFinite(_this.props.initialSelectionEnd)) {
          inputElement.setSelectionRange(_this.props.initialSelectionStart, _this.props.initialSelectionEnd);
        } else {
          inputElement.select();
        }
      };

      _this.onFocus = function (e) {
        e.target.addEventListener('mouseup', preventNextMouseUp); // Safari deselect on mouse up fix

        _this.isCanceled = false;
        _this.valueOnFocus = e.target.value;

        if (_this.props.selectOnFocus) {
          _this.selectContent();
        }

        _this.props.onFocus(e);
      };

      _this.onBlur = function (e) {
        _this.scrollInputToTopIfNeeded();

        _this.timers.reFocus = window.setTimeout(function () {
          if (!window.document.hasFocus()) {
            window.addEventListener('focus', _this.reFocus);
          }
        }, 0);

        if (_this.isCanceled && _this.props.revertValueOnCancel) {
          var isValid = true;

          _this.props.onChange(_this.props.successValue || _this.valueOnFocus, isValid);
        }

        _this.props.onBlur(e, _this.isCanceled);

        if (_this.props.preventBlur) {
          _this.reFocus();
        }
      };

      _this.reFocus = function () {
        _this.focusInput();

        window.removeEventListener('focus', _this.reFocus);
      };

      _this.getInputClassName = function () {
        var inputHeightClass = commonPropTypes.INPUT_HEIGHT_OPTIONS.includes(_this.props.inputHeight) ? " ".concat(_this.props.inputHeight) : '';
        var additionalClass = (_this.props.innerInputClass || '') + (_this.props.inputTextSuffix ? ' has-text-suffix' : '') + inputHeightClass;
        return _this.props.getClassName("".concat(_this.props.defaultInputClass, " ").concat(additionalClass));
      };

      _this.getInputProps = function () {
        return {
          ref: 'input',
          type: _this.props.type || 'text',
          className: _this.getInputClassName(),
          value: _this.props.inputWithStateHandler ? _this.state.value : _this.props.value,
          onChange: _this.handleChange,
          disabled: _this.isDisabled(),
          readOnly: _this.props.isReadOnly,
          placeholder: _this.props.translateIfNeeded(_this.props.placeholder) || '',
          maxLength: _this.props.maxLength,
          spellCheck: false,
          onKeyDown: _this.handleKeyDown,
          onFocus: _this.onFocus,
          onBlur: _this.onBlur,
          onWheel: _this.props.shouldBlockOuterScroll ? _this.props.blockOuterScroll : _.noop,
          dir: _this.props.dir,
          name: _this.uniqueId,
          id: _this.uniqueId
        };
      };

      _this.getRootCssClasses = function () {
        return ['input-container', _this.isDisabled() ? 'is-disabled' : '', _this.props.success ? 'success' : '', _this.props.invalidMessage ? 'invalid' : '', _this.props.unit ? "".concat(_this.props.unit, "-unit") : ''].join(' ');
      };

      return _this;
    }

    _createClass(Input, [{
      key: "UNSAFE_componentWillMount",
      value: function UNSAFE_componentWillMount() {
        this.uniqueId = this.props.focusOnPrefixClick ? _.uniqueId('baseuilib-input-') : undefined;
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        if (!this.props.isReadOnly && this.props.autoSelect) {
          this.timers.initialFocus = window.setTimeout(this.focusInput.bind(this, true), 0);
        } else if (this.props.focus) {
          this.timers.initialFocus = window.setTimeout(this.focusInput.bind(this), 0);
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        // Changing state's value in case handling input value from state, and input wrapper forced new value from props
        if (this.props.inputWithStateHandler && !_.isUndefined(this.props.value) && this.props.value !== this.state.value) {
          this.setState({
            value: this.props.value
          });
        }

        if (!this.props.isReadOnly && prevProps.isReadOnly) {
          this.timers.writeableFocus = window.setTimeout(this.focusInput.bind(this, true), 0);
        }

        if (this.props.selectionActionCounter !== prevProps.selectionActionCounter) {
          this.selectContent();
        }
      }
    }, {
      key: "UNSAFE_componentWillUpdate",
      value: function UNSAFE_componentWillUpdate(nextProps) {
        if (nextProps.focus && (!this.props.focus || this.focusFailed)) {
          window.clearTimeout(this.timers.blurUpdate);
          this.timers.focusUpdate = window.setTimeout(this.focusInput.bind(this), 0);
        } else if (!nextProps.focus && this.props.focus) {
          window.clearTimeout(this.timers.focusUpdate);
          this.timers.blurUpdate = window.setTimeout(this.blurInput.bind(this), 0);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        _.forEach(this.timers, function (timer) {
          return window.clearTimeout(timer);
        });
      }
    }, {
      key: "render",
      value: function render() {
        return template.call(this);
      }
    }]);

    return Input;
  }(React.Component);

  Input.displayName = displayName;
  Input.propTypes = commonPropTypes.INPUT_PROP_TYPES;
  Input.defaultProps = _.assign({}, {
    disabled: false,
    blurOnEnterKey: true,
    blurOnEscKey: true,
    shouldBlockOuterScroll: false,
    placeholder: '',
    dir: 'ltr',
    onKeyDown: _.noop,
    onBlur: _.noop,
    onFocus: _.noop,
    focusOnPrefixClick: false,
    showInfoTooltip: false,
    infoTooltipProps: {},
    isReadOnly: false,
    autoSelect: false,
    selectOnFocus: true,
    revertValueOnCancel: true,
    defaultInputClass: 'input',
    preventBlur: false,
    selectionActionCounter: 0
  }, defaultPropOverride);
  return Input;
};

module.exports = createInputClass;